// extracted by mini-css-extract-plugin
export default {"node_normal":"style_node_normal__QGQ9K","react-flow__node":"style_react-flow__node__SaqT-","selected":"style_selected__fZ598"};